import React, { useEffect, useState } from "react";
import "./domain.css";
import DomainListItem from "./components/DomainListItem";
import AddDomainModal from "./modal/AddDomainModal";
import useDomainList from "../../utils/CustomHooks/useDomainList";
import PaginationComponent from "../../components/PaginationComponent";
import withRoleBased from "../../utils/Functions/withRoleBased";
import { sortArray } from "../../utils/Functions/filter";

function Domain({ access }) {
  const [count, setCount] = useState(0);
  const [isOpen, setIsOpen] = useState(false);
  const { domainList, loading, getDomainList } = useDomainList("");
  const [currentPage, setCurrentPage] = useState(0);
  const [pageSize] = useState(10);
  const pageCount = Math.ceil(domainList.length / pageSize);
  const [search, setSearch] = useState("");
  const [isSearching, setIsSearch] = useState(false);

  useEffect(() => {
    let req = {};
    if (search) req.domain_name = search;
    getDomainList(req);
  }, [count]);

  const handleClick = (event, index) => {
    event.preventDefault();
    setCurrentPage(index);
  };

  const onSearch = () => {
    setCurrentPage(0)
    setCount((x) => x + 1);
    setIsSearch(search ? true : false);
  };
  
  return (
    <main className="page-content">
      <div className="container-fluid">
        <div className="row  m-0 w-100">
          <div className="col-md-6 mb-3">
            <h5 className="page-title"> Domain </h5>
          </div>

          <div className="col-md-6  mb-3 d-flex justify-content-end">
            {access.canCreate && (
              <button
                type="button"
                className="btn btn-outline-success "
                onClick={() => setIsOpen(true)}
              >
                Create Domain
              </button>
            )}
          </div>

          <div className="col-md-4">
            <div className="search" style={{ margin: "16px 0px 32px" }}>
              <input
                type="text"
                className="form-control"
                placeholder="Search"
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                onKeyDown={(e) => e.key === "Enter" && onSearch()}
              />
              {!isSearching ? (
                <button onClick={onSearch}>
                  <i className="fa fa-search" />
                </button>
              ) : (
                <button
                  onClick={() => {
                    setSearch("");
                    setIsSearch(false);
                    setCount((x) => x + 1);
                  }}
                >
                  <i className="fa fa-times" />
                </button>
              )}
            </div>
          </div>
          <div className="col-md-12">
            <div className="table-responsive ">
              <table className="table table-borderless">
                <thead>
                  <tr className=" ">
                    <td className="col-sm-2">Domain Name</td>
                    <td className={access.canEdit ? "col-sm-4" : "col-sm-7"}>
                      Description{" "}
                    </td>
                    <td className="col-sm-3">Status</td>
                    {access.canEdit && <td className="col-sm-3">Action</td>}
                  </tr>
                </thead>
                <tbody>
                  {!loading && domainList && domainList.length > 0 ? (
                    sortArray(domainList)
                      .slice(
                        currentPage * pageSize,
                        (currentPage + 1) * pageSize
                      )
                      .map((x, i) => (
                        <DomainListItem
                          key={i}
                          item={x}
                          index={i}
                          refresh={() => setCount((x) => x + 1)}
                          access={access}
                        />
                      ))
                  ) : (
                    <tr>
                      <td colSpan="4" className="text-center">
                        <span className="font-weight-bold">
                          {loading ? "Loading..." : "Oops! No Data Found"}
                        </span>
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
        {domainList.length > 0 && pageCount != 1 && (
          <PaginationComponent
            handleClick={handleClick}
            currentPage={currentPage}
            pageCount={pageCount}
          />
        )}

        <AddDomainModal
          isOpen={isOpen}
          setOpen={() => setIsOpen(false)}
          refresh={() => setCount((x) => x + 1)}
        />
      </div>
    </main>
  );
}

export default withRoleBased(Domain, "domain");
